import { render, staticRenderFns } from "./LeakFreeView.vue?vue&type=template&id=0beaee86&lang=html"
import script from "./LeakFreeView.vue?vue&type=script&lang=js"
export * from "./LeakFreeView.vue?vue&type=script&lang=js"
import style0 from "./LeakFreeView.vue?vue&type=style&index=0&id=0beaee86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports